import { Button } from "@/components/ui/UIElements/Button";
import React from "react";
import { Icon } from "../";

const BrandCard = ({ brand, onViewDetails, onDelete }) => {
  const getBorderColor = () => {
    return brand.enabled ? "border-success/50" : "border-destructive/50";
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete && onDelete(brand);
  };

  const handleViewDetailsClick = (e) => {
    e.stopPropagation();
    onViewDetails?.();
  };

  return (
    <article
      className={`ordering-brand-card bg-background hover:bg-card cursor-pointer rounded-lg border p-4 transition-colors ${getBorderColor()}`}
      onClick={onViewDetails}
    >
      {/* Brand Info */}
      <div className="space-y-2">
        {/* Logo and Name */}
        <div className="flex items-center space-x-3">
          {brand.logo ? (
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-12 w-12 flex-shrink-0 rounded-lg object-cover"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div className="bg-card flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg">
              <Icon name="Building" className="text-muted-foreground h-6 w-6" />
            </div>
          )}

          <div className="min-w-0 flex-1">
            <h3 className="text-foreground line-clamp-2 text-sm leading-tight font-semibold">
              {brand.name || brand?.internal_name}
            </h3>
            <p className="text-muted-foreground mt-1 text-xs">
              {brand?.internal_name || ""}
            </p>
          </div>
        </div>
      </div>

      {/* Footer - View Details and Delete */}
      <div className="border-border mt-2 border-t pt-3">
        <div className="flex items-center justify-between">
          <Button
            variant="ghost"
            type="button"
            onClick={handleDeleteClick}
            className="text-destructive hover:text-destructive flex items-center space-x-1 transition-colors"
          >
            <Icon name="Trash2" className="h-4 w-4" />
            <span>Delete</span>
          </Button>
          <Button
            variant="ghost"
            type="button"
            onClick={handleViewDetailsClick}
            className="ordering-brand-card-action text-primary hover:text-primary flex items-center justify-end transition-colors"
          >
            <span className="me-1">View Details</span>
            <Icon name="ChevronRight" className="h-3 w-3" />
          </Button>
        </div>
      </div>
    </article>
  );
};

export default BrandCard;
